export class Upload {
    name: string; // 파일명 또는 파일 경로

    value: any; // Base64 인코딩된 파일 데이터 ->  ex) data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD...

    size: number; // 파일 크기 (바이트 단위)

    _preview: any;
}
